var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityShippingGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95.9995,
    height: 96,
    rx: 47.9997,
    fill: "#EBF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3906 48.0366C39.8755 47.9614 41.3592 48.2081 42.7397 48.7595C44.1201 49.311 45.3648 50.1543 46.3881 51.2315C49.4363 55.3684 51.6505 60.0574 52.9077 65.0378",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.383 72H49.8173C49.282 72.0005 48.755 71.8668 48.2848 71.6112C47.8146 71.3555 47.4161 70.9861 47.1259 70.5367C44.9656 67.1182 41.9524 64.3195 38.382 62.4153C31.984 59.2204 25.5859 56.0255 25.5859 48.0382C25.5859 36.8561 33.5835 35.2586 38.382 35.2586C46.3795 35.2586 54.377 43.2459 59.1755 44.8433C55.9765 40.051 49.4164 25.0669 54.377 24.0765C62.3745 22.479 67.173 46.4408 67.173 46.4408C68.7105 47.1014 70.001 48.2281 70.8622 49.6615C71.7233 51.0948 72.1114 52.7623 71.9715 54.428C71.9715 59.2204 68.7725 59.2204 63.974 59.2204C59.1755 59.2204 57.576 60.8178 57.576 60.8178",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7812 51.2344C64.9934 51.2344 65.1968 51.3185 65.3468 51.4683C65.4967 51.6181 65.581 51.8213 65.581 52.0331",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9824 52.0331C63.9824 51.8213 64.0667 51.6181 64.2167 51.4683C64.3666 51.3185 64.5701 51.2344 64.7822 51.2344",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7822 52.83C64.5701 52.83 64.3666 52.7458 64.2167 52.596C64.0667 52.4462 63.9824 52.2431 63.9824 52.0312",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.581 52.0312C65.581 52.2431 65.4967 52.4462 65.3468 52.596C65.1968 52.7458 64.9934 52.83 64.7812 52.83",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7275 39.9326C26.8212 39.7253 25.9947 39.2595 25.3485 38.5919C24.7022 37.9243 24.2641 37.0835 24.0875 36.1719C23.9108 35.2602 24.0031 34.3169 24.3531 33.4567C24.7032 32.5964 25.296 31.8563 26.0594 31.3262C26.8229 30.7962 27.724 30.499 28.6534 30.4709C29.5827 30.4429 30.5002 30.685 31.2943 31.168C32.0885 31.651 32.725 32.354 33.1265 33.1915C33.528 34.029 33.6773 34.965 33.5561 35.8857",
    stroke: "#808080",
    strokeWidth: 3.19901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityShippingGraphic);
export default __webpack_public_path__ + "static/media/priority-shipping-graphic.3dfeeed0070201591323ad4b95312a36.svg";
export { ForwardRef as ReactComponent };